import React from 'react';
import { Container } from './CheckboxSection.styles';
import { Paragraph, tokens } from '@welbe/web-design-system';
import { Accordion } from '../Accordion/Accordion';
import { JobRiskFactorsProps, StepProps } from '../../FormRisk.types';

type CheckboxSectionProps = {
	steps: StepProps[];
	jobRiskFactors: JobRiskFactorsProps[];
};

export const CheckboxSection = ({
	steps,
	jobRiskFactors,
}: CheckboxSectionProps) => {
	return (
		<Container>
			<Paragraph
				padding=" 10px 20px"
				fontSize="18px"
				fontWeight="400"
				color={tokens.color_primary}
			>
				Factores de riesgo
			</Paragraph>
			<hr />
			<Accordion steps={steps} jobRiskFactors={jobRiskFactors} />
		</Container>
	);
};
